export default __webpack_public_path__ + "static/media/sugbil-logo@240x240.758e043e.png";